

<div class="big-caret mysec" > 
  <!-- typewriter -->
<ng-container *ngFor="let node of nodes;trackBy: trackById">
<ng-container *ngIf="node">
  <ng-container *ngIf="node.tag === 'text';else def">
    
  <span [outerHTML]="node.text"></span>
  </ng-container>
  <ng-template #def>
<!-- <br>
---------------
{{node| json}}
---------------
<br> -->
<!-- --------------- -->
<!-- {{node| json}} -->
<!-- {{generateElementHtml(node) | json}} -->
    
<!-- ---------------
<br> -->
<!-- {{node.attributes.class | json}} -->
<!-- {{node.attributes.class | json}} -->
<ng-template #popTemplate id="commentPopover">
<ng-container *ngIf="getContext(node) as obj">
  <div class="c_header" *ngIf="obj?.additionalProperties as prop">
    <div>
      <span class="doc_reference">{{prop?.contextId}}</span>&nbsp;&nbsp;
      <span class="title"><a target="_blank" [attr.href]="prop?.record.url1">{{prop?.record.filename}}</a></span>
    </div>
    <a target="_blank" [attr.href]="prop?.record.url1"><img class="max_icon" [src]="'./assets/maximise_icon.png'"></a>
  </div>
  <div class="pop_section_body" *ngIf="obj?.part?.text">
    <span>
      <span class="doc_reference">
        {{obj.activehover}}
      </span> &nbsp;&nbsp;
    </span>
        <div class="contain_section"[innerHTML]="obj?.part?.text | boldStar"></div>
    
  </div>
</ng-container>
</ng-template>

<ng-container *ngIf="node.attributes.class == 'doc_reference stickypopover';else def">  
<span  class="popover_trigger" [stickyPopover]="popTemplate"  placement="auto" triggers="manual">
  <span class="htmlcontainer" [outerHTML]="generateElementHtml(node)"></span>
</span>
</ng-container>
<ng-template #def>
  <span class="htmlcontainer" [outerHTML]="generateElementHtml(node)"></span>
</ng-template>
  <!-- <div class="children" *ngIf="node.children?.length">
  <app-html-node *ngFor="let child of node.children" [node]="child"></app-html-node>
  </div> -->


  
  </ng-template>
  </ng-container>
</ng-container>
</div>